module.exports = __webpack_public_path__ + "static/media/orpheus_docs.384278c0.wav";